// extracted by mini-css-extract-plugin
export default {"titleStyle":"templateHeader_titleStyle__OaRWW","titleStyleWrapper":"templateHeader_titleStyleWrapper__sYKH4","stepStatus":"templateHeader_stepStatus__f9Nen"};